import { render, staticRenderFns } from "./ROC.vue?vue&type=template&id=43b55044&"
import script from "./ROC.vue?vue&type=script&lang=js&"
export * from "./ROC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports